import { postRequest } from '../../../shared/utils';

// Query existing PSP records by composite key (design_owner_id, pf_lc, mp_nr)
export async function getPspRecordsByKey(
  designOwnerId: number,
  pfLc: number,
  mpNr: string,
  screenGridId: number,
  columns: string[] = ['id', 'design_owner_id', 'pf_lc', 'mp_nr', 'active'], // fallback
) {
  const body = {
    columns,
    screenGridId,
    schema: 'npi',
    table: 'psptable',
    key: 'mp_nr',
    filterModel: {
      items: [
        { field: 'design_owner_id', value: designOwnerId ?? '', operator: 'is' },
        { field: 'pf_lc', value: pfLc ?? '', operator: 'is' },
        { field: 'mp_nr', value: mpNr ?? '', operator: 'equals' },
        { field: 'active', value: 1, operator: 'is' },
      ],
      logicOperator: 'and',
    },
    limitNumber: 200,
    orderCol: 'mp_nr',
    order: 'asc',
  };

  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    console.error(errors);
    return null;
  }
  return data;
}
